import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

// @NgModule装饰器 @NgModule接收一个元数据对象 告诉angular如何编译和启动应用
@NgModule({
  declarations: [AppComponent],
  imports: [CoreModule],
  bootstrap: [AppComponent],
})
// 根模块其实不需要导出 因为其他组件不需要引入根模块
export class AppModule {}
